/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
/**
 * Enumerates possible display modes for section headers.
 */
export var DataSourceSectionHeaderDisplayMode = /*@__PURE__*/ (function (DataSourceSectionHeaderDisplayMode) {
    /**
     * Each group is preceded by a single section header that combines multiple groups into one.
     */
    DataSourceSectionHeaderDisplayMode[DataSourceSectionHeaderDisplayMode["Combined"] = 0] = "Combined";
    /**
     * Each group may be preceded by multiple section headers, one for each group.
     */
    DataSourceSectionHeaderDisplayMode[DataSourceSectionHeaderDisplayMode["Split"] = 1] = "Split";
    return DataSourceSectionHeaderDisplayMode;
})({});
/**
 * @hidden
 */
export var DataSourceSectionHeaderDisplayMode_$type = /*@__PURE__*/ markEnum('DataSourceSectionHeaderDisplayMode', 'Combined,0|Split,1');
//# sourceMappingURL=DataSourceSectionHeaderDisplayMode.js.map
